import useAction from '@shared/hooks/useAction';
import { buildVersion } from '@shared/util/env';
import { useSelector } from 'react-redux';
import { Reducer } from 'redux';

const APP_VERSION_UPDATED = 'APP_VERSION_UPDATED';
const APP_UPDATE_DISMISSED = 'APP_UPDATE_DISMISSED';

const actionCreators = {
  appVersionUpdated: () => ({ type: APP_VERSION_UPDATED }) as const,
  appUpdateDismissed: () => ({ type: APP_UPDATE_DISMISSED }) as const,
};

export const { appVersionUpdated } = actionCreators;

type Action = ReturnType<(typeof actionCreators)[keyof typeof actionCreators]>;

type State = {
  version: number;
  status: 'up-to-date' | 'update-pending' | 'update-dismissed';
};

const initialState = {
  version: buildVersion,
  status: 'up-to-date',
} as const;

const appVersion: Reducer<State, Action> = (state = initialState, action) => {
  switch (action.type) {
    case APP_VERSION_UPDATED:
      return { ...state, status: 'update-pending' };
    case APP_UPDATE_DISMISSED:
      return { ...state, status: 'update-dismissed' };
    default:
      return state;
  }
};

export default appVersion;

type RootState = { appVersion: State };

// SELECTORS

const isAppUpdatePendingSelector = ({ appVersion }: RootState) =>
  appVersion.status === 'update-pending';

export const useIsAppUpdatePending = () => useSelector(isAppUpdatePendingSelector);

export const useDismissAppUpdate = () => useAction(actionCreators.appUpdateDismissed);
